'use strict';

import { CATEGORYONELEVEL } from "../constants/ActionTypes";

const initState = {
    AD_IMG:null,
    GET_CRUMBS:null,
    GET_PATH:null,
    GET_CONTENTS:null
};
export default function ( state = initState, action = {} ){
    switch( action.type ){
        
       case CATEGORYONELEVEL.GET_AD_IMG :
            return Object.assign({},state,{
                AD_IMG : action.AD_IMG
            });
        break;
       case CATEGORYONELEVEL.GET_CRUMBS :
            return Object.assign({},state,{
                GET_CRUMBS : action.GET_CRUMBS
            });
        break;
        case CATEGORYONELEVEL.GET_PATH :
            return Object.assign({},state,{
                GET_PATH : action.param
            });
        break;
         case CATEGORYONELEVEL.GET_CONTENTS :
            return Object.assign({},state,{
                GET_CONTENTS : action.GET_CONTENTS
                
            });
        break;
        default:
            return state;break;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/categoryOnelevel.js